module.exports = __webpack_public_path__ + "media/images/mobile/solutions/18-4eff727477f9f0a49c95521171233e5f.png";